(function ($) {
  // Utility object which houses various useful functions
  var utils = require("./utils");

  // create the defaults once
  var pluginName = "jsOptions";

  // the plugin constructor
  function Plugin(providerElement, config) {
    this._defaults = $.fn[pluginName].defaults;
    this._name = pluginName;

    this.config = $.extend(true, {}, this._defaults, config);

    this.$provider = $(providerElement);
    // this.$providers = this.$container.find('.js-option-provider');
    // this.$consumers = this.$container.find('.js-option-consumer');

    // this.$provider = this.$providers.find( utils.createIDSelectorFromString(this.config.providerID) );

    // this.$consumer = this.$consumers.find( utils.createIDSelectorFromString(this.config.consumerID) );

    // // Making sure that these singular vars default to the collection, in case it is still undefined
    // this.$provider = this.$provider.length ? this.$provider : this.$providers;
    // this.$consumer = this.$consumer.length ? this.$consumer : this.$consumers;

    this.init();
  }

  Plugin.prototype = {
    init: function () {
      // initialisation logic goes here

      /**
       *
       * INIT
       * ------------------------------
       * If there are already 'selected' elements, assume that the page is being
       * loaded in its EDIT MODE; i.e. the server is supplying the form fields
       * with information it (the page) has previously saved (during its ADD MODE)
       *
       */

      // Bind handler for when a 'change' event occurs
      // if (this.$provider.length) {

      this.$provider.on("change", this.processConsumers.bind(this));

      //   // if (!$.isEmptyObject(this.$provider.val()) ) {
      //   //   // console.log('this.provider.val',this.$provider.val() );
      //   //   // console.log('this.provider.val isEmptyObject', $.isEmptyObject(this.$provider.val()) );
      //   //   this.$provider.trigger('change');
      //   // }
      // }
    },

    // getAjaxUrl: function () {

    //     // Build up the URL
    //     if ( !$.isEmptyObject(this.config.ajaxObject) ) {
    //       var jxObject = this.config.ajaxObject,
    //           jxURL = jxObject['prefix'] + jxObject['url'] + jxObject['query'] + jxObject['param'];

    //           return jxURL;
    //     } else {
    //         return undefined;
    //     }

    // },

    processConsumers: function (e) {
      // For single-select fields

      // Fetch the lastest value snapshot of the 'js-option-provider'
      var providerSelection = this.$provider.find(":selected").val();
      var consumers;
      var _self = this;

      if ($.isArray(this.config.consumers)) {
        consumers = this.config.consumers;

        $.each(consumers, function (index, target) {
          // Update query string
          target.query = _self.fetchQueryString(
            target.q,
            _self.$provider.attr("name"),
            providerSelection,
          );

          // Check and Save any pre-selection on the target
          target.preselection = $(target.id).val();

          // Hand-off the current 'consumer' to be processed
          _self.updateConsumer(target);
        });
      }

      // // Check if there are any selected Slave <option>s
      // var consumerSelection = this.$consumer.find(':selected').val();
      // console.log('consumerSelection', consumerSelection)
      // if ( providerSelection.length ) {

      //   if ( !$.isEmptyObject(this.config.ajaxObject) ) {
      //     this.config.ajaxObject.param = providerSelection;

      //     if ( !$.isEmptyObject(consumerSelection) ) { // There is a selected <option>

      //       // preserve the selected <option>s while updating the Slave list
      //       this.consumerPopulateWithAjax(consumerSelection);

      //     } else {

      //       // Simply do a copy from Master to Slaves
      //       this.consumerPopulateWithAjax();
      //     }
      //   }
      // } else {
      //   this.resetConsumer( this.$consumer );
      // }
    },

    fetchQueryString: function (query, param, value) {
      var queryString = "";

      if ($.isEmptyObject(query)) {
        queryString = "?" + param + "=" + value;
      } else {
        queryString = query + value; // Assumption here is that 'query' is already formed correctly: "?param="
      }
      return queryString;
    },

    updateConsumer: function (consumer) {
      // Form the url to be used for fetching content
      var url = consumer.contentSource + consumer.query;
      var $consumer = $(consumer.id);
      var _self = this;

      $.getJSON(url, function (response) {

        var $optionsList = $('<option value=""></option>');

        $.each(response, function (optionElemKey, optionElemValue) {
          $optionsList = $optionsList.add(
            $("<option>").val(optionElemKey).text(optionElemValue),
          );
        });

        _self.resetConsumer($consumer);

        $consumer.append($optionsList);

        $consumer.val(consumer.preselection);

        $consumer.trigger("chosen:updated");
      });
    },

    // consumerPopulateWithAjax: function () {

    //   this.ajaxURL = this.getAjaxUrl();

    //   if ( this.ajaxURL == undefined ) {
    //     throw new Error("Cannot populate using this URL");
    //   }

    //   console.log("this.provider", this.$provider);
    //   console.log("this.consumer", this.$consumer);
    //   console.log("ajaxUrl", this.ajaxURL); // Comment out for testing using `.hbs` templates

    //   var SELF = this;
    //   $.getJSON(
    //     SELF.ajaxURL,
    //     function( result ) {
    //         var datasetObject;
    //         datasetObject = $.isPlainObject(result) ? result : {};

    //         // for testing using `.hbs` templates
    //         if (SELF.config.isFrontendDevEnv) {
    //           datasetObject = (result.datasetId)[SELF.config.ajaxObject.param];
    //         }

    //         console.log("result JSON", datasetObject);
    //         var $optionsList = $('<option value=""></option>');

    //         $.each( datasetObject, function (optionElemKey, optionElemValue) {

    //             $optionsList = $optionsList.add(
    //               $('<option>')
    //                 .val(optionElemKey)
    //                 .text(optionElemValue)
    //             );

    //         });

    //       // Make sure that Slave(s) are clean, to reflect 'no Master selection'
    //       SELF.resetConsumer( SELF.$consumer );

    //       // Update the 'js-option-consumer'
    //       SELF.$consumer.append( $optionsList ).trigger('chosen:updated');

    //       // Further update the consumer by marking any passed-in 'pre-selection';
    //       // e.g. when the form page is being viewed in a state following its initial filling-out
    //       if (arguments.length > 0) {
    //         if (typeof arguments[0] === 'string') { // Verify it's a string value
    //           SELF.$consumer.val(arguments[0]).trigger('chosen:updated');
    //         }
    //       }

    //     }
    //   );
    // },

    /**
     * Totally wipe clean, all Slaves;
     * i.e. Remove all exisiting <option>s from all Slaves
     */
    resetConsumer: function ($consumer) {
      if (!$consumer.hasClass("js-option-consumer")) {
        throw new Error(
          "The $consumer element parameter is expected to have a class 'js-option-consumer'",
        );
      }

      // Clean out the Slave completely
      utils.clearSelectedOpts($consumer);
      utils.removeAllOpts($consumer);
    },

    resetAllConsumers: function ($consumers) {
      $consumers.each(
        $.proxy(function (index, consumer) {
          this.resetConsumer(consumer);
        }, this),
      );
    },
  };

  /**
   *
   * lightweight plugin wrapper around the constructor to prevent
   * against multiple instantiations
   *
   **/

  $.fn[pluginName] = function (config) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, config));
      }
    });
  };

  // Reference: http://ryanflorence.com/use-your-fn-jquery-namespace/ ; Sept 2017 ; Chie

  /**
   *
   * attaching the 'defaults' object to the 'fn' namespace so as to offer
   * developers access to decide what the defaults should be for their
   * particular application
   *
   **/

  $.fn[pluginName].defaults = {
    // ajaxObject: {
    //   prefix: "",
    //   url: "/grantSectionsForDataset.json",
    //   query: "?datasetId=",
    //   param: ""
    // },
    // willAjax: true,
    isFrontendDevEnv: false,
    // ,
    // consumerID: "grantSection",
    // providerID: "datasetName"
  };
})(jQuery);
